import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHdm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 5,
		cy: 9,
		rx: 5,
		ry: 3,
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 7L5 0",
		stroke: "black",
		strokeWidth: 1.5
	})]
});
export default SvgHdm;
